module.exports = __webpack_public_path__ + "src/assets/img/recommendation-1-1.f4c5e52a.png";